import { render, staticRenderFns } from "./compareSurvey.vue?vue&type=template&id=539ddd1b&scoped=true"
import script from "./compareSurvey.vue?vue&type=script&lang=js"
export * from "./compareSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ddd1b",
  null
  
)

export default component.exports